import './logo.scss'

export function Logo() {
  return (
    <div className="container__logo">
      <p className="primeira-letra__logo">IMB</p>
      <p>Consultoria</p>
    </div>
  )
}
